"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogActions = exports.subtitle = exports.closeIcon = exports.title = exports.dialogTitle = exports.dialogRoot = void 0;

var _react = require("@emotion/react");

var _utils = require("../../../utils");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 8px 0 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  max-width: calc(100% - 32px);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dialogRoot = function dialogRoot(mobileFullscreen) {
  return function (theme) {
    return (0, _react.css)((0, _utils.mq)(theme)(_defineProperty({}, "> .MuiDialog-container > .MuiDialog-paperFullWidth", {
      top: [mobileFullscreen ? 12 : 'auto', 'unset'],
      height: [mobileFullscreen ? 'auto' : 'fit-content'],
      maxHeight: 'calc(100% - 12px)'
    })));
  };
};

exports.dialogRoot = dialogRoot;

var dialogTitle = function dialogTitle(hasSubtitle) {
  return function (theme) {
    return (0, _react.css)((0, _utils.mq)(theme)({
      borderBottom: "1px solid ".concat(theme.colors.neutral[200]),
      textAlign: [hasSubtitle ? 'left' : 'center', 'left'],
      padding: [16, '32px 32px 24px']
    }));
  };
};

exports.dialogTitle = dialogTitle;
var title = (0, _react.css)(_templateObject());
exports.title = title;

var closeIcon = function closeIcon(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    width: 24,
    height: 24,
    cursor: 'pointer',
    position: 'absolute',
    right: [16, 32]
  }));
};

exports.closeIcon = closeIcon;

var subtitle = function subtitle(theme) {
  return (0, _react.css)(_templateObject2(), theme.colors.neutral[500]);
};

exports.subtitle = subtitle;

var dialogActions = function dialogActions(scrollable, spaceActions) {
  return function (theme) {
    return (0, _react.css)((0, _utils.mq)(theme)(_defineProperty({
      borderTop: scrollable ? "1px solid ".concat(theme.colors.neutral[200]) : 'unset',
      borderRadius: [0, scrollable ? 0 : theme.radii.lg],
      justifyContent: spaceActions ? 'space-between' : 'flex-end',
      flexDirection: spaceActions ? 'row-reverse' : 'row'
    }, "&.MuiDialogActions-spacing", {
      '& > :not(:first-child)': {
        marginLeft: spaceActions ? 'unset' : 12
      }
    })));
  };
};

exports.dialogActions = dialogActions;